import { Alert, AlertDescription, Button } from "@tellescope/ui";
import { Card } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

interface AdminOrganizationMismatchProps {
  urlOrganizationName: string;
  urlHost: string;
  sessionOrganizationName: string;
  onLogout: () => void;
  onContinueAnyway?: () => void;
}

export const AdminOrganizationMismatch = ({
  urlOrganizationName,
  urlHost,
  sessionOrganizationName,
  onLogout,
  onContinueAnyway,
}: AdminOrganizationMismatchProps) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <Card variant="floating" padding="root" className="w-full max-w-lg">
        <Card.Header className="text-center">
          <Card.Title className="text-2xl font-bold flex items-center justify-center gap-2">
            <AlertTriangle className="h-6 w-6 text-destructive" />
            {t("Wrong organization for this portal")}
          </Card.Title>
        </Card.Header>
        <Card.Body className="space-y-4">
          <p className="text-muted-foreground">
            {t("{{urlHost}} serves the portal for {{urlOrganizationName}}.", { urlHost, urlOrganizationName })}
          </p>
          <p className="text-muted-foreground">
            {t("You are signed in to {{sessionOrganizationName}}.", { sessionOrganizationName })}
          </p>
          <Alert variant="destructive">
            <AlertDescription>
              {t(
                "Saving here would overwrite {{sessionOrganizationName}}'s portal with this configuration, so editing is disabled.",
                { sessionOrganizationName }
              )}
            </AlertDescription>
          </Alert>
          <div className="flex justify-center gap-2 pt-2">
            <Button onClick={onLogout}>{t("Logout")}</Button>
            {onContinueAnyway && (
              <Button variant="outline" onClick={onContinueAnyway}>
                {t("Continue anyway")}
              </Button>
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};
